export const API = "https://api.relayr.ba5ed.com";
export const DASHBOARD = "https://relayr.ba5ed.com";
